var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiquid = function SvgLiquid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.97 122.88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#42A5F5",
    d: "M40.95,0c7.88,33.66,17.45,35.4,33.8,60.69c4.25,6.57,7.22,13.56,7.22,21.58c0,11.14-4.02,20.69-12.07,28.65 c-8.08,7.96-17.71,11.96-28.93,11.96c-11.19,0-20.8-4-28.88-11.96C4.03,102.96,0,93.41,0,82.27c0-8.06,3.02-15.1,7.31-21.71 C23.69,35.33,33.22,33.55,40.95,0L40.95,0L40.95,0z M17.57,71.78c2.29-0.21,4.31,1.48,4.51,3.76c0.52,5.52,1.73,10.61,4.04,15 c2.23,4.24,5.55,7.89,10.35,10.7c1.98,1.16,2.64,3.71,1.48,5.68c-1.16,1.98-3.71,2.64-5.68,1.48c-6.25-3.66-10.58-8.42-13.51-13.99 c-2.95-5.61-4.36-11.85-4.95-18.12C13.6,74.02,15.3,71.99,17.57,71.78L17.57,71.78z"
  }))));
};
export default SvgLiquid;